import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Label, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { requestIcon } from '../constants';
import WaitingIcon from '../components/WaitingIcon';
import { showTransferRequest } from '../actions';
import { requestAccessContext, accessControlForTransfer } from '../helper';
import { resolveRequestWorkflow } from '../state/state';

const RequestStatus = ({
  allowTransfer,
  category,
  code,
  request,
  showTransfer,
}) => {
  const { icon, message } = requestIcon(request, allowTransfer);

  return (
    <Label
      className={clsx(`aridhia-request-status-${request.status}`)}
      as={allowTransfer ? 'a' : undefined}
      onClick={allowTransfer ? (() => showTransfer(category, code)) : undefined}
    >
      <Icon name={icon} />
      <FormattedMessage id={message} />
      {request.waiting && <WaitingIcon className="ml-10" />}
    </Label>
  );
};

const mapStateToProps = ({
  auth: { role, currentUser },
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(
    requests,
    workflows,
    ownProps,
    { status: '', waiting: false, requester: { uuid: '', active: false } },
  );
  const context = requestAccessContext(request, currentUser);

  return (
    {
      allowTransfer: accessControlForTransfer(context, role.permissions).allowTransfer,
      request,
    }
  );
};

const mapDispatchToProps = {
  showTransfer: showTransferRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestStatus);
